"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrescriptionType = void 0;
var PrescriptionType;
(function (PrescriptionType) {
    PrescriptionType[PrescriptionType["Drug"] = 0] = "Drug";
    PrescriptionType[PrescriptionType["Dressings"] = 1] = "Dressings";
    PrescriptionType[PrescriptionType["NarcoticsRecipe"] = 2] = "NarcoticsRecipe";
    PrescriptionType[PrescriptionType["NursingAids"] = 3] = "NursingAids";
    PrescriptionType[PrescriptionType["AdisForConsumption"] = 4] = "AdisForConsumption";
    PrescriptionType[PrescriptionType["AidsForUse"] = 5] = "AidsForUse";
    // PrescriptionType = 6 is currently used in the aquinet API on customer side.
    // We override the 6 to 0 in the interface. Consider this when changing the enum.
    PrescriptionType[PrescriptionType["TubeFeeding"] = 7] = "TubeFeeding";
})(PrescriptionType = exports.PrescriptionType || (exports.PrescriptionType = {}));
exports.default = PrescriptionType;
